var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.313,
    height: 34.313,
    viewBox: "0 0 34.313 34.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-circle-right",
    "data-name": "Icon awesome-arrow-circle-right",
    d: "M17.719.563A17.157,17.157,0,1,1,.563,17.719,17.154,17.154,0,0,1,17.719.563Zm-2,9.934,5.223,5.009H8.311a1.656,1.656,0,0,0-1.66,1.66v1.107a1.656,1.656,0,0,0,1.66,1.66H20.943L15.72,24.941a1.662,1.662,0,0,0-.028,2.373l.761.754a1.653,1.653,0,0,0,2.345,0l9.18-9.173a1.653,1.653,0,0,0,0-2.345L18.8,7.363a1.653,1.653,0,0,0-2.345,0l-.761.754a1.67,1.67,0,0,0,.028,2.38Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeArrowCircleRight);
export default __webpack_public_path__ + "static/media/Icon awesome-arrow-circle-right.a0fe7b140858b440b54e150dec130932.svg";
export { ForwardRef as ReactComponent };